module.exports = __webpack_public_path__ + "static/media/User.4aca9df7.svg";